const wowApp = require('angular').module('wowApp.common');

const { BootstrapService } = require('./bootstrap.service');

wowApp.service('BootstrapService', BootstrapService);



// WEBPACK FOOTER //
// ./src/common/bootstrap/index.js